import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@scio3/ui';
import { useBillingDialogStore } from '../stores/billing-dialog-store';
import PaymentMethodPage from '../pages/PaymentMethodPage';

/**
 * Billing Information dialog — shown from the paywall (InactiveAccountDialog) for
 * accounts with `isTrial=false, isActive=false`. Wraps PaymentMethodPage in limited
 * view (banner + unpaid invoices + card form only) to match scio1's
 * updateBillingInformationModal layout.
 *
 * On successful card update, hard-reloads the page so every Apollo query, Zustand
 * store, and company-scoped cache refreshes with the now-active subscription
 * state (mirrors scio1's $state.go('paymentThankYou') navigation).
 */
export function BillingInformationDialog() {
  const { t } = useTranslation();
  const activeDialog = useBillingDialogStore((s) => s.activeDialog);
  const closeDialog = useBillingDialogStore((s) => s.closeDialog);
  const isOpen = activeDialog === 'billingInformation';

  const handlePaymentSaved = () => {
    window.location.reload();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent
        data-testid="billing-information-dialog"
        className="flex max-h-[85vh] max-w-2xl flex-col overflow-hidden"
      >
        <DialogHeader>
          <DialogTitle>{t('Billing Information')}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto">
          <PaymentMethodPage forceLimitedView onPaymentSaved={handlePaymentSaved} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
